import whyChoosePaladinImg from '../../assets/images/landingpage/whychoosepaladin.png';

const items = [
  {
    number: "01",
    title: "Trustworthy by Design",
    description:
      "Protect your home with comprehensive insurance coverage against unexpected damage or loss.",
  },
  {
    number: "02",
    title: "Deep Industry Authority",
    description:
      "Our advisors bring specialized knowledge to every engagement — confident, precise guidance you can rely on.",
  },
  {
    number: "03",
    title: "Advocacy at Every Step",
    description:
      "From policy selection to claims support, we champion your interests and advocate on your behalf without hesitation.",
  },
];

export default function WhyChoosePaladinSection() {
  return (
    <section className="w-full bg-white py-20 px-6">
      <div className="max-w-4xl mx-auto">

        {/* Eyebrow */}
        <div className="flex items-center justify-center gap-3 mb-5">
          <div className="w-8 h-px bg-blue-900" />
          <span
            className="font-serif text-blue-900 uppercase text-xs font-normal"
            style={{ letterSpacing: "0.22em" }}
          >
            WHY <strong className="font-bold">PALADIN</strong>
          </span>
        </div>

        {/* Headline */}
        <h2
          className="text-center font-serif font-bold text-blue-950 leading-tight mb-5 whitespace-nowrap"
          style={{ fontSize: "clamp(28px, 4.5vw, 56px)", letterSpacing: "-0.01em" }}
        >
          Insurance Built on{" "}
          <em className="italic font-normal">Integrity</em>
        </h2>

        {/* Subtext */}
        <p className="text-center font-serif text-base text-gray-700 leading-relaxed max-w-lg mx-auto mb-14">
          We don't just sell policies. We build long-term partnerships grounded
          in expertise, transparency, and a genuine stake in your success.
        </p>

        {/* Navy Card */}
        <div
          className="flex overflow-hidden rounded-2xl p-5 gap-6"
          style={{ backgroundColor: "#0d2d6e" }}
        >
          {/* Left: Handshake Image - inset via parent padding */}
          <div
            className="hidden sm:block flex-shrink-0 bg-cover bg-center rounded-xl"
            style={{
              width: "38%",
              minHeight: "360px",
              backgroundImage: `url(${whyChoosePaladinImg})`, // Uses the imported variable
            }}
          />

          {/* Right: Numbered Items */}
          <div className="flex flex-col justify-center flex-1 px-12 py-12">
            {items.map(({ number, title, description }, i) => (
              <div
                key={number}
                className={
                  i < items.length - 1
                    ? "pb-8 mb-8 border-b border-white/10"
                    : ""
                }
              >
                {/* Number + Title row */}
                <div className="flex items-baseline gap-4 mb-2">
                  <span className="font-serif text-base font-bold text-white/70 tracking-wide flex-shrink-0">
                    {number}
                  </span>
                  <h3 className="font-serif text-xl italic font-normal text-white leading-snug">
                    {title}
                  </h3>
                </div>

                {/* Description indented past number */}
                <p className="font-serif text-sm text-white/60 leading-relaxed pl-10">
                  {description}
                </p>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}